import { DataService } from '@/config/dataService/dataService';

const ROLE_KEY   = 'pos_role';
const BRANCH_KEY = 'pos_branch_office_id';
const NAME_KEY   = 'pos_user_name';

const state = {
  role:           localStorage.getItem(ROLE_KEY)   || null,
  branchOfficeId: localStorage.getItem(BRANCH_KEY) ? parseInt(localStorage.getItem(BRANCH_KEY)) : null,
  user:           localStorage.getItem(NAME_KEY)   ? { name: localStorage.getItem(NAME_KEY) } : null,
};

const mutations = {
  SET_POS_ROLE(state, { role, user }) {
    state.role = role;
    state.user = user;
    const branchId = user?.pos_branch_office_id ?? null;
    state.branchOfficeId = branchId ? parseInt(branchId) : null;

    if (role) {
      localStorage.setItem(ROLE_KEY, role);
    } else {
      localStorage.removeItem(ROLE_KEY);
    }
    if (branchId) {
      localStorage.setItem(BRANCH_KEY, String(branchId));
    } else {
      localStorage.removeItem(BRANCH_KEY);
    }
    if (user?.name) {
      localStorage.setItem(NAME_KEY, user.name);
    } else {
      localStorage.removeItem(NAME_KEY);
    }
  },
};

// Role hierarchy
const HIERARCHY = ['cajero', 'supervisor', 'gerente'];

const getters = {
  posRole:           (state) => state.role,
  posUser:           (state) => state.user,
  posBranchOfficeId: (state) => state.branchOfficeId,
  // true if user has at least minRole
  hasPosRole: (state) => (minRole) => {
    if (!state.role) return false;
    return HIERARCHY.indexOf(state.role) >= HIERARCHY.indexOf(minRole);
  },
  isCajero:    (state) => !!state.role,
  isSupervisor:(state) => HIERARCHY.indexOf(state.role) >= 1,
  isGerente:   (state) => state.role === 'gerente',
};

const actions = {
  async fetchPosRole({ commit }) {
    try {
      const res = await DataService.get('pos/me');
      if (res.data && res.data.data) {
        commit('SET_POS_ROLE', {
          role: res.data.data.pos_role,
          user: res.data.data,
        });
      }
    } catch (e) {
      // token inválido o no autenticado — no hacer nada
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
